module.exports = __webpack_public_path__ + "static/media/manageclient.3279f17b.svg";